<div class="head-page">
  <h2 class="page-title">{{step1 ? 'Nouveau code' : 'Attribution de votre code'}}</h2>
  <div class="gln-example">
    <img src="/assets/images/gln-example.svg" alt="Exemple de GLN">
  </div>
  <p class="gs1-little">{{step1 ?
    'Vous allez procéder à la création d’un nouveau code GLN. Merci de remplir les champs suivants.'
      : 'Afin de valider la création de votre code GLN, veuillez cliquer sur terminer.'}}</p>

  <gs1-accordion-item class="gs1-spacer-5" [title]="'Comment codifier ?'">
    <h4>Règles de codification GS1</h4>
    <p class="gs1-little">
      Le GLN (Global Location Number) est le standard international utilisé par les entreprises pour identifier l’entité et ses différents sites : entrepôts, usines, service facturation ou comptabilité, quais de chargement/déchargement...
      <br/>
      Un GLN principal est attribué par GS1 France au moment de l’adhésion et l’entreprise peut ensuite créer autant de GLN secondaires (ou applicatifs) que nécessaire.
    </p>
    <p class="gs1-little">
      Seul le/la propriétaire du lieu est habilité à codifier les lieux. Codifier à sa place est contraire aux règles de codification GS1.
    </p>
  </gs1-accordion-item>
</div>
<form *ngIf="GLNForm; else loader" [formGroup]="GLNForm" [ngClass]="{'step2': !step1}">
  <ng-container *ngIf="step1">
    <!-- Global info -->
    <div class="card-wrapper">
      <span class="progress-title gs1-little"><i class="bi bi-{{getGLNInfosState()[0] + ' gs1-color-'+ getGLNInfosState()[1]}}"></i>Informations GLN</span>
      <div class="card gs1-spacer-4">
        <div class="card-form">
          <gs1-checkbox-group [label]="'Que souhaitez-vous codifier ?'" [helper]="'Plusieurs choix possibles'" formGroupName="glnType" class="full-width">
            <gs1-checkbox [disabled]="isMobilePhysical"  *ngIf="isMobilePhysical" [name]="'physical'"  >
              Lieu physique
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Tous types de lieu rattachés à une adresse postale. Exemple : Une usine, un site d\'entreprise, un quai etc.'"></span>
            </gs1-checkbox>

            <gs1-checkbox [disabled]="isMobilePhysical"  *ngIf="!isMobilePhysical" [name]="'physical'" formControlName="isFixedPhysicalLocation">
              Lieu physique
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Tous types de lieu rattachés à une adresse postale. Exemple : Une usine, un site d\'entreprise, un quai etc.'"></span>
            </gs1-checkbox>


            <gs1-checkbox *ngIf="environment==='uat'" [name]="'mobile'" formControlName="isMobilePhysicalLocation" (ngModelChange)="onCheckboxChange($event)" [(ngModel)]="isMobilePhysical">
              Lieu mobile
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Un lieu tangible amené à se déplacer à différents endroits/emplacements. Exemple : un food-truck, un bateau etc.'"></span>
            </gs1-checkbox>
            <gs1-checkbox [disabled]="isMobilePhysical" *ngIf="isMobilePhysical" [name]="'function'"  >
              Fonction
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Représente un service, une équipe, un département organisationnel. Exemple : un service de facturation etc.'"></span>
            </gs1-checkbox>
            <gs1-checkbox   *ngIf="!isMobilePhysical" [name]="'function'" formControlName="isFunction">
              Fonction
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Représente un service, une équipe, un département organisationnel. Exemple : un service de facturation etc.'"></span>
            </gs1-checkbox>
            <gs1-checkbox [disabled]="isMobilePhysical" *ngIf="isMobilePhysical" [name]="'digital'" >
              Lieu digital
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Une adresse digitale représentée par une url, un serveur informatique, un site internet, etc.'"></span>
            </gs1-checkbox>
            <gs1-checkbox *ngIf="!isMobilePhysical"  [name]="'digital'" formControlName="isDigitalLocation">
              Lieu digital
              <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="'Une adresse digitale représentée par une url, un serveur informatique, un site internet, etc.'"></span>
            </gs1-checkbox>


           </gs1-checkbox-group>
           <div style="display: flex; flex-direction: column;width: 100%;">


          <gs1-select-wrapper>
            <label for="language">Langue du GLN</label>
            <span slot="helper">Langue utilisée pour les informations de ce GLN.</span>
            <ng-select formControlName="language" name="language" [bindValue]="'value'" [bindLabel]="'fr'" [notFoundText]="'Aucun résultat trouvé'"
              [clearable]="false" [hideSelected]="true" [items]="languages" [searchable]="true" [multiple]="false" [closeOnSelect]="true"></ng-select>
          </gs1-select-wrapper>
           </div>
          <!-- <gs1-input [name]="'parentOrganisationGLN'" formControlName="parentOrganisationGLN" [label]="'GLN Parent (optionnel)'" [helper]="'&nbsp;'">
            <span slot="error" *ngIf="showError('parentOrganisationGLN')">Ce GLN n'est pas valide</span>
          </gs1-input> -->
          <gs1-input [name]="'Name'" formControlName="name" [label]="'Nom du GLN'" [helper]="'Nom de l\'organisme, du lieu ou de la fonction organisationnelle que vous identifiez.'" class="full-width">
            <span slot="error" *ngIf="showError('name')">Le nom n'est pas valide</span>
          </gs1-input>
          <div class="form">
            <gs1-input class="internCode" *ngIf="shouldShowCodeNumber() && GLNForm.get('organisationCode')?.value === organisationCode[1].value" [name]="'codeNumberIntern'" formControlName="codeNumberIntern" [placeholder]="'14 caractères maximum.'">
              <span slot="error" *ngIf="showError('codeNumberIntern')">Ce code n’est pas valide</span>
            </gs1-input>

            <gs1-input class="siret" *ngIf="shouldShowCodeNumber() && GLNForm.get('organisationCode')?.value  === organisationCode[0].value" [name]="'codeNumberSiret'" formControlName="codeNumberSiret" [placeholder]="'14 chiffres.'">
              <span slot="error" *ngIf="showError('codeNumberSiret')">Ce code n'est pas correct</span>
            </gs1-input>
            <gs1-radios class="full-width" [label]="'Associez un code organisationnel à votre GLN (optionnel)'" style="white-space: nowrap;">
              <gs1-radio formControlName="organisationCode" [value]="organisationCode[0].value" [name]="organisationCode[0].label"
                         [label]="organisationCode[0].label" (checkChanged)="GLNForm.get('codeNumberIntern')?.setValue(null)"></gs1-radio>
              <gs1-radio formControlName="organisationCode" [value]="organisationCode[1].value" [name]="organisationCode[1].label"
                         [label]="organisationCode[1].label" (checkChanged)="GLNForm.get('codeNumberSiret')?.setValue(null)">
              </gs1-radio>
            </gs1-radios>
          </div>
          <gs1-select-wrapper>
            <label for="roleType">Rôle du GLN (optionnel)</label>
            <span slot="helper">Rôle de l'organisme, du lieu, de la fonction.</span>
            <ng-select formControlName="roleType" name="roleType" [clearable]="true" [bindValue]="'value'" [notFoundText]="'Aucun résultat trouvé'" [bindLabel]="'label'" [items]="roleTypesListFilter" [searchable]="true" [multiple]="false"  [closeOnSelect]="true"></ng-select>
          </gs1-select-wrapper>
        </div>
      </div>
    </div>
    <!-- Localisation -->
    <div  class="card-wrapper">

      <span class="progress-title gs1-little"><i class="bi bi-{{getAdressState()[0] + ' gs1-color-'+ getAdressState()[1]}}"></i>Localisation</span>
      <div class="card gs1-spacer-4" *ngIf="isMobilePhysical" >
        <div class="card-form">
      <gs1-select-wrapper   >
        <label for="mobileLocationValue">Emplacement fréquent (optionnel)</label>
         <span slot="helper">Nom ou GLN rattaché à ce lieu mobile.</span>






<!-- <ng-select bindLabel="gln" formControlName="mobileLocationValue" [searchable]="false" [clearable]="false"
  [hideSelected]="true">
  <ng-option *ngFor="let item of glnsFormated" value="{{item.id}}"><span style="font-size:15px;"
      [innerHTML]="item.name"> </span></ng-option>
</ng-select> -->
<ng-select bindLabel="gln" formControlName="mobileLocationValue"   [searchable]="false" [clearable]="false" (ngModelChange)="onSelect($event)"> [hideSelected]="true">
  <ng-option *ngFor="let item of glnsFormated" value="{{item.id}}">
    <span style="font-size:15px;" [innerHTML]="(selectedItem && item.id === selectedItem.id) ? getFormattedText(item).replace('\<br>', '').replace('\</br>', ''):getFormattedText(item)"></span>
    <span style="display: none;">  {{(selectedItem && item.id === selectedItem.id) ? '':'.'}}</span>
  </ng-option>
</ng-select>

      </gs1-select-wrapper>
        </div>
      </div>
      <div class="card gs1-spacer-4" *ngIf="!isMobilePhysical"  formGroupName="address">
        <div class="card-form">

          <gs1-input class="full-width" *ngIf="!isMobilePhysical" [name]="'streetAddress'" type="address" (onAddressChange)="AddressChange($event)" formControlName="streetAddress" [label]="'Adresse'">
            <span slot="error" *ngIf="showError('address.streetAddress', 'maxlength')">L'adresse ne peut excéder 80 caractères</span>
          </gs1-input>
          <gs1-input class="full-width" *ngIf="!isMobilePhysical" [name]="'streetAddress2'" formControlName="streetAddress2" [label]="'Complément d\'adresse (optionnel)'">
            <span slot="error" *ngIf="showError('address.streetAddress2', 'maxlength')">Le complément d'adresse ne peut excéder 80 caractères</span>
          </gs1-input>
          <gs1-input *ngIf="!isMobilePhysical" [name]="'postalCode'" formControlName="postalCode" [label]="'Code postal'" class="postal-code">
            <span slot="error" *ngIf="showError('address.postalCode', 'maxlength')">Le code postal ne peut excéder 9 caractères</span>
          </gs1-input>
          <gs1-input *ngIf="!isMobilePhysical" [name]="'addressLocality'" formControlName="addressLocality" [label]="'Ville'" class="city">
            <span slot="error" *ngIf="showError('address.addressLocality', 'maxlength')">La ville ne peut excéder 50 caractères</span>
          </gs1-input>
          <gs1-select-wrapper *ngIf="!isMobilePhysical" class="country">
              <label for="countryCode">Pays</label>
              <ng-select formControlName="countryCode" name ="countryCode" [bindValue]="'Code alpha-2'" [notFoundText]="'Aucun résultat trouvé'" [bindLabel]="'wording-fr'" [items]="countryList" [searchable]="true" [multiple]="false" [closeOnSelect]="true" [hideSelected]="true"></ng-select>
          </gs1-select-wrapper>
        </div>
      </div>
    </div>
    <!-- Localisation -->
    <div class="card-wrapper">
      <span class="progress-title gs1-little"></span>
      <div class="card gs1-spacer-4">
        <div class="card-form">
          <gs1-input [name]="'digitalAddress'" formControlName="digitalAddress"
            [helper]="'Url, serveur informatique, code GLN, etc.'" [maxlength]="80">
            <label for="digitalAddress">Adresse digitale {{isDigitalAdressRequired() ? '' : ' (optionnel)'}}</label>
          </gs1-input>
          <gs1-input [name]="'URL'" [helper]="'Url de votre site internet.'" formControlName="url" [label]="'Site internet (optionnel)'"></gs1-input>
        </div>
      </div>
    </div>
    <!-- Contact -->
    <div class="card-wrapper">
      <span class="progress-title gs1-little"><i class="bi bi-check-circle-fill gs1-color-blue"></i> Contact</span>
      <div class="card gs1-spacer-4" formGroupName="contact">
        <div class="card-form">
          <gs1-input [name]="'lastName'" formControlName="lastName" [label]="'Nom (optionnel)'"></gs1-input>
          <gs1-input [name]="'firstName'" formControlName="firstName" [label]="'Prénom (optionnel)'"></gs1-input>
          <gs1-input [name]="'email'" formControlName="email" [label]="'Adresse mail professionnelle (optionnel)'">
            <span slot="error" *ngIf="showError('contact.email')">Cet email n'est pas valide</span>
          </gs1-input>
          <gs1-phone [name]="'phone'" formControlName="phone" [label]="'Téléphone professionnel (optionnel)'">
            <span slot="error" *ngIf="showError('contact.phone')">Ce téléphone n'est pas valide</span>
          </gs1-phone>
        </div>
      </div>
    </div>
    <p class="gs1-legal legal-block">
      Les informations recueillies ici par GS1 France font l’objet d’un traitement destiné à permettre l'usage de Codeonline GLN et pourront, selon les choix effectués sur votre interface, être transmises à des tiers, adhérents à GS1 France.
      <br/>
      Conformément aux dispositions de la loi n°78-17 du 6 janvier 1978 dite « Informatique et Libertés » modifiée, au Règlement UE 2016/679 ou à toute autre disposition normative qui viendrait le compléter ou s’y substituerait, chaque personne, dont les données personnelles sont collectées, dispose d’un droit d’accès, de modification, de rectification et de suppression de ces dernières. Toute personne dont les données personnelles sont collectées dispose également du droit de s’opposer, pour des motifs légitimes, à leur traitement. Ces droits peuvent être exercés à tout moment en adressant un email à <a href="mailto:serviceclient@gs1fr.org">serviceclient@gs1fr.org</a> ou un courrier à Service client GS1 France, 21 boulevard Haussmann 75009 Paris, en nous indiquant la raison sociale de son entreprise, sa référence adhérent, ses nom et prénom, accompagnés de la copie de sa pièce d’identité.
      <br/>
      Pour plus d’information, vous pouvez consulter notre <a target="_blank" href="https://www.gs1.fr/politique-confidentialite">Politique de Confidentialité</a>.
    </p>


    <div class="button-wrapper">
      <button gs1Button [appearance]="'outlined'" [disabled]="!canSave()" [pending]="saving" (click)="saveGLN()">Enregistrer le brouillon</button>
      <div [matTooltip]="hasOnlyCNUD() ? 'Votre code entreprise ne vous permet plus de créer de nouveaux codes GLN. Si vous souhaitez en créer de nouveaux, merci de contacter notre Service Adhérent au 01 40 22 18 00 ou par mail au serviceclient@gs1fr.org' : (hasUsableGCP() ? 'Merci de remplir les champs obligatoires' : 'Vous n\'avez  plus de capacité de codification. Pour commander un nouveau GCP, rendez-vous sur votre espace client.')" [matTooltipDisabled]="GLNForm.valid" [matTooltipPosition]="'above'">
        <button gs1Button [disabled]="!GLNForm.valid" (click)="changeStep(true)" [pending]="loadingGLN">Créer</button>
      </div>

    </div>
  </ng-container>

  <ng-container *ngIf="!step1">
    <div class="step2-row">
      <div class="card gs1-background-color-ui-1 gs1-spacer-3">
        <span class="gln gs1-color-blue" *ngIf="!loadingGLN">{{GLNForm.get('gln')?.value}}</span>
        <span gs1Spinner *ngIf="loadingGLN" [size]="'1.6em'"></span>
      </div>

        <gs1-toggle [color]="forest" formControlName="isPublished" [name]="'isPublished'">
        <span>
          Publier
          <i class="bi bi-question-circle-fill gs1-color-blue" matTooltip="La publication rend le GLN visible sur les registres GS1 ainsi que les données à caractère personnel renseignées." [matTooltipPosition]="'above'"></i> </span>
      </gs1-toggle>
    </div>
    <div class="card gln-selection gs1-spacer-4">
      <p class="gs1-color-slate-accessible"><i class="bi bi-pencil"></i> Edition avancée</p>
      <p class="gs1-little gs1-color-slate-accessible">
        Vous pouvez choisir de codifier votre code GLN avec un autre de vos préfixes entreprise.<br/>
        Le code se mettra à jour avec votre choix de préfixe.
      </p>
      <div class="false-field"  *ngIf="gcps.length>1; else inputfield">
        <p class="gs1-color-ui-6 gs1-little">Préfixe</p>
        <ng-select  formControlName="licenceKey" name ="licenceKey" [disabled]="loadingGLN" [bindLabel]="'gcp'"[clearable]="false" [searchable]="false" [multiple]="false" [closeOnSelect]="true" [hideSelected]="true">
          <ng-option *ngFor="let item of gcps" [value]="item.key" [disabled]="!item.value"><a class="gs1-color-blue">{{item.key}}</a> </ng-option>
        </ng-select>
      </div>
      <ng-template #inputfield>
        <div class="false-field">
          <p class="gs1-color-ui-6 gs1-little">Préfixe</p>
          <p class="gs1-color-black gs1-little" style="padding-top:4px;"> <span *ngIf="!loadingGLN" class="gs1-color-blue gs1-little">{{this.splittedGLN[0]}}</span> <span style="display: inline-block;" gs1Spinner *ngIf="loadingGLN" [size]="'1.2em'"></span></p>
      </div>
      </ng-template>
      <div class="false-field">
        <p class="gs1-color-ui-6 gs1-little">Plage d'attribution &nbsp;&nbsp;{{this.glnSuffix.length}}/{{12-this.splittedGLN[0].length}}&nbsp;&nbsp;<span *ngIf="glnIsValid; else notValid" style="display: inline-block;"> </span></p>
        <div class="gln-suffix-input">
          <div style="display: flex; flex-wrap: wrap; justify-content: flex-end;" ><input  class="gs1-color-blue gs1-little range-input" [name]="'glnSuffix'" formControlName="glnSuffix" maxlength="{{this.glnRange}}" [(ngModel)]="glnSuffix" (keyup)="onKeySearch($event)" value="{{this.splittedGLN[1]}}"/>  <i *ngIf="!glnIsUsed" style="position: absolute; padding-top: 4px; display: flex; align-items: center; padding: 8px 8px 9px 3px; margin-bottom: 0; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #495057; text-align: center; white-space: nowrap;" class="bi bi-check-circle-fill gs1-color-forest-accessible"> </i>
            <i *ngIf="glnIsUsed" style="position: absolute; padding-top: 4px; display: flex; align-items: center; padding: 8px 8px 9px 3px; margin-bottom: 0; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #495057; text-align: center; white-space: nowrap;" class="bi bi-x-circle-fill gs1-color-danger"> </i>

          </div>
        <div> <span class="gs1-color-danger gs1-small" *ngIf="glnIsUsed">Ce code est déjà utilisé, veuillez le changer.</span>  </div>
        </div>

        <ng-template #notValid>
        </ng-template>
      </div>
      <div class="false-field">
        <p class="gs1-color-ui-6 gs1-little">Clé</p>
        <p class="gs1-color-blue gs1-little" style="padding-top:4px;"><span *ngIf="!loadingGLN" class="gs1-color-blue gs1-little">{{this.splittedGLN[2]}}</span></p>
      </div>
    </div>
    <div class="button-wrapper">
      <button gs1Button [appearance]="'outlined'" (click)="changeStep(false)">Retour</button>
      <button gs1Button *ngIf="!(currentGln?.status && currentGln?.status !== 'DRAFT')" (click)="sendGLN()" [pending]="sending" [disabled]="!GLNForm.valid || loadingGLN || !glnIsValid">Terminer</button>
    </div>
  </ng-container>
</form>

<ng-template #loader>
  <div gs1Spinner [big]="true" [size]="'30px'"></div>
</ng-template>

<ng-template #glnDisplay>
  <div class="card">
    <div class="false-field">
      <p class="gs1-color-ui-6 gs1-little">Préfixe</p>
      <p class="gs1-color-blue gs1-little">{{GLNForm.get('licenceKey')?.value}}</p>
    </div>
    <div class="false-field">
      <p class="gs1-color-ui-6 gs1-little">Préfixe</p>
      <p class="gs1-color-blue gs1-little">{{GLNForm.get('gln')?.value}}</p>
    </div>
  </div>
</ng-template>
